import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { DiaCalendario } from './DiaCalendario';
import { TarjetaTarea } from './TarjetaTarea';
import { construirDiasMes, formatearIdDia, obtenerEventosDia } from './calendarioUtils';

const nombresDias = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];

export const CalendarioGrid = ({
    mesActual,
    tareas,
    onSelectDay,
    onChanged,
    mostrarFinesSemana = false,
}) => {
    const [filasExpandidas, setFilasExpandidas] = useState({});
    const diasMes = useMemo(() => construirDiasMes(mesActual), [mesActual]);
    const diasVisibles = useMemo(
        () => mostrarFinesSemana
            ? diasMes
            : diasMes.filter((dayValue) => dayValue.getDay() !== 0 && dayValue.getDay() !== 6),
        [diasMes, mostrarFinesSemana]
    );
    const hoyId = formatearIdDia(new Date());
    const mesReferencia = mesActual.getMonth();
    const columnas = mostrarFinesSemana ? 7 : 5;

    const toggleExpandirFila = (fila) => {
        setFilasExpandidas((prev) => ({
            ...prev,
            [fila]: !prev[fila],
        }));
    };

    return (
        <Box
            sx={{
                width: '100%',
                minWidth: 0,
                display: 'grid',
                gridTemplateColumns: `repeat(${columnas}, minmax(0, 1fr))`,
                gap: 0.7,
                alignItems: 'start',
            }}
        >
            {diasVisibles.map((dayValue, index) => {
                const idDia = formatearIdDia(dayValue);
                const tareasDelDia = obtenerEventosDia(tareas, idDia);
                const fila = Math.floor(index / columnas);
                const expandido = Boolean(filasExpandidas[fila]);
                const visibles = expandido ? tareasDelDia : tareasDelDia.slice(0, 3);
                const tareasOcultas = Math.max(tareasDelDia.length - 3, 0);
                const isCurrentMonth = dayValue.getMonth() === mesReferencia;
                const nombreDia = nombresDias[dayValue.getDay() === 0 ? 6 : dayValue.getDay() - 1];

                return (
                    <DiaCalendario
                        key={idDia}
                        id={idDia}
                        dia={dayValue.getDate()}
                        nombreDia={nombreDia}
                        isExpanded={expandido}
                        isToday={idDia === hoyId}
                        isCurrentMonth={isCurrentMonth}
                        onSelectDay={onSelectDay}
                    >
                        {visibles.map((tarea) => (
                            <TarjetaTarea key={tarea.id} id={tarea.id} tarea={tarea} onChanged={onChanged} />
                        ))}

                        {(tareasOcultas > 0 || expandido) && (
                            <Box
                                onClick={(event) => {
                                    event.stopPropagation();
                                    toggleExpandirFila(fila);
                                }}
                                sx={{
                                    mt: 0.25,
                                    textAlign: 'center',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: 'var(--principal)',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                }}
                            >
                                {expandido ? 'Ver menos' : `+ ${tareasOcultas} tareas por ver`}
                            </Box>
                        )}
                    </DiaCalendario>
                );
            })}
        </Box>
    );
};
